// singtel cognito config
export const COGNITO = {
    REGION: process.env.REACT_APP_AWS_REGION,
    USER_POOL_ID: process.env.REACT_APP_USER_POOL_ID,
    APP_CLIENT_ID: process.env.REACT_APP_APP_CLIENT_ID,
    ACCESS_KEY_ID: "",   // Your user pool accesskeyId
    SECRET_ACCESS_KEY: "",  // Your user pool secretaccesskey
};